/**
 * Decides whether the RentCafe tracker should run even though analytics are
 * switched off, which is always the case on the dev server. The
 * `clicktrack_debug` param opts the tracker back in there, without waking up GA
 * or tourAnalytics.js.
 *
 * This only controls whether ClickTrack runs. Logging what it sends is a
 * separate concern that the same param drives in every environment.
 *
 * NODE_ENV is inlined at build time, so this override is compiled out of the
 * staging and production bundles and cannot be enabled from a deployed tour.
 */
const shouldForceClickTrackInDev = (debug: boolean) =>
  debug && process.env.NODE_ENV !== 'production';

export default shouldForceClickTrackInDev;
